"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommerceService = void 0;
var rest_service_1 = require("./rest.service");
var enums_1 = require("../shared/enums");
var auth_service_1 = require("./auth.service");
/**
 * Class declaration
 */
var CommerceService = /** @class */ (function (_super) {
    __extends(CommerceService, _super);
    /**
     * constructor
     */
    function CommerceService(brandService) {
        var _this = this;
        var authServiceInstance = new auth_service_1.AuthService();
        _this = _super.call(this, {
            serviceName: enums_1.ServicesEnum.COMMERCE,
            baseURL: brandService.config.commerceServiceUrl,
            authService: authServiceInstance,
        }) || this;
        _this.productsResourcePath = 'products';
        _this.subscriptionsResourcePath = 'subscriptions';
        _this.authService = authServiceInstance;
        return _this;
    }
    /**
     * @param subscriptionId Subscription UUID
     * @returns a Subscription
     */
    CommerceService.prototype.getSubscription = function (subscriptionId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.show(this.subscriptionsResourcePath, subscriptionId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_1 = _a.sent();
                        throw new Error("Unable to get subscription ".concat(subscriptionId, " -> ") + rejectReason_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param legacy_school_id Legacy school id, if null will get from jwt token
     * @returns List of Subscription
     */
    CommerceService.prototype.listSubscription = function (legacy_school_id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!legacy_school_id) {
                            legacy_school_id = this.authService.schoolId;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.search(this.subscriptionsResourcePath, { legacy_school_id: legacy_school_id })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 3:
                        rejectReason_2 = _a.sent();
                        throw new Error("Unable to list subscriptions of ".concat(legacy_school_id, " -> ") + rejectReason_2);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update an Subscription
     * @param subscriptionId Subscription UUID to be updated
     * @param subscription Subscription
     * @returns Updated Subscription
     */
    CommerceService.prototype.updateSubscription = function (subscriptionId, subscription) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.update(this.subscriptionsResourcePath, subscription, subscriptionId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_3 = _a.sent();
                        throw new Error("Unable to update with identifier ".concat(subscriptionId, " -> ") + rejectReason_3);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Post an Subscription
     * @param subscription
     * @returns Updated Subscription
     */
    CommerceService.prototype.saveSubscription = function (subscription) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.request(this.subscriptionsResourcePath, enums_1.RequestMethodEnum.POST, subscription)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_4 = _a.sent();
                        throw new Error('Unable to create new subscription -> ' + rejectReason_4);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param queryParams Object with
     *      - q: number | string
     *      - grade: Array of [K, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
     *      - subject: Array of [BIBLE, ELECTIVES, ELECTIVES_CAREER_COURSES, ELECTIVES_STATE_HISTORY, HISTORY_AND_GEOGRAPHY, LANGUAGE_ARTS, MATH, OTHER, SCIENCE]
     *      - course_type: One of ELECTIVE | CORE
     *      - include_packages: boolean
     *      - offset: number
     *      - limit: number
     * @returns Paginated object with list of Products
     */
    CommerceService.prototype.getProducts = function (queryParams) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.search(this.productsResourcePath, queryParams, false)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_5 = _a.sent();
                        throw new Error('Unable to get products -> ' + rejectReason_5);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param productIdentifier Product UUID or slug
     * @returns Product
     */
    CommerceService.prototype.getProduct = function (productIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var response, rejectReason_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.search("".concat(this.productsResourcePath, "/").concat(productIdentifier), null, false)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        rejectReason_6 = _a.sent();
                        throw new Error("Unable to get product with identifier ".concat(productIdentifier, " -> ") + rejectReason_6);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CommerceService;
}(rest_service_1.RestService));
exports.CommerceService = CommerceService;
